import { DateTime } from "luxon";

export const formatearFecha = (fecha: Date): string => {
  const opciones: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "America/Bogota",
  };
  return Intl.DateTimeFormat("es-ES", opciones).format(fecha);
};

export const formatearFechaStr = (fecha: string): string => {
  const dt = DateTime.fromISO(fecha);
  const date = dt.toJSDate();
  const opciones: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return Intl.DateTimeFormat("es-ES", opciones).format(date);
};

export const formatearFechaCortaStr = (fecha: string): string => {
  const dt = DateTime.fromISO(fecha);
  const date = dt.toJSDate();
  const opciones: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  return Intl.DateTimeFormat("es-ES", opciones).format(date);
};

export const formatearAnoMes = (fecha: Date): string => {
  const opciones: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: undefined,
  };
  return Intl.DateTimeFormat("es-ES", opciones).format(fecha);
};

export const formatearTiempo = (fecha: Date): string => {
  const opciones: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  return Intl.DateTimeFormat("es-ES", opciones).format(fecha);
};

export const formatearTiempoStr = (tiempo: string): string => {
  const date = stringADate(tiempo);
  const opciones: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: "America/Bogota",
  };
  return Intl.DateTimeFormat("es-ES", opciones).format(date);
};

export const addDays = (date: Date, days: number) => {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const datesRange = (start: Date, end: Date) => {
  let dateArray = new Array<Date>();
  var currentDate = start;
  while (currentDate <= end) {
    dateArray.push(new Date(currentDate));
    currentDate = addDays(currentDate, 1);
  }
  return dateArray;
};

export const calcularFechaMin = (fechas: Date[]) => {
  if (fechas.length === 0) {
    return null;
  }
  return fechas.reduce((previousValue, currentValue) => {
    if (previousValue < currentValue) {
      return previousValue;
    } else {
      return currentValue;
    }
  });
};

export const normalizarFecha = (fecha: Date) => {
  return new Date(fecha.toString().replace(/-/g, "/"));
};

export const dateEquals = (a: Date, b: Date) => {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
};

export const dateCompare = (a: Date, b: Date): number => {
  if (a.getFullYear() > b.getFullYear()) {
    return 1;
  }
  if (a.getFullYear() < b.getFullYear()) {
    return -1;
  }
  if (a.getMonth() > b.getMonth()) {
    return 1;
  }
  if (a.getMonth() < b.getMonth()) {
    return -1;
  }
  if (a.getDate() > b.getDate()) {
    return 1;
  }
  if (a.getDate() < b.getDate()) {
    return -1;
  }
  return 0;
};

export const dateCompareStr = (a: string, b: string): number => {
  const dtA = DateTime.fromISO(a);
  const dtB = DateTime.fromISO(b);
  if (dtA > dtB) {
    return 1;
  }
  if (dtA < dtB) {
    return -1;
  }
  return 0;
};

export const ordenarFechas = (fechas: Date[]): Date[] => {
  let ordenadas = fechas;
  ordenadas.sort((a, b) => {
    if (a > b) {
      return 1;
    } else if (b > a) {
      return -1;
    } else {
      return 0;
    }
  });
  return ordenadas;
};

export const obtenerStringDeFecha = (fecha: Date): string => {
  if (
    fecha.getUTCHours() === 0 &&
    fecha.getUTCMinutes() === 0 &&
    fecha.getUTCSeconds() === 0 &&
    fecha.getUTCMilliseconds() === 0
  ) {
    return fecha.toISOString().slice(0, 10);
  }

  const fechaUTC = new Date(
    Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate())
  );
  return fechaUTC.toISOString().slice(0, 10);
};

export const stringADate = (fecha: string): Date => {
  const dt = DateTime.fromISO(fecha);
  return dt.toJSDate();
};

export const esDiaSiguiente = (fechaA: string, fechaB: string): boolean => {
  const dtA = DateTime.fromISO(fechaA);
  const dtB = DateTime.fromISO(fechaB);
  if (!dtA.isValid) {
    throw Error("Fecha a invalida " + fechaA);
  }
  if (!dtB.isValid) {
    throw Error("Fecha b invalida " + fechaB);
  }

  return esDiaSiguienteDT(dtA, dtB);
};

const esDiaSiguienteDT = (dtA: DateTime, dtB: DateTime): boolean => {
  const diff = dtA.diff(dtB, ["days"]);
  return dtA > dtB && diff.days === 1;
};

export const obtenerIntervalos = (fechas: string[]): Array<Array<string>> => {
  if (fechas.length === 1) {
    return [fechas];
  }

  const intervalos: Array<Array<DateTime>> = [];

  let dts: DateTime[] = fechas.map((f) => DateTime.fromISO(f));
  dts.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));

  intervalos.push([dts[0]]);
  for (let i: number = 1; i < dts.length; i++) {
    const ultimoIntervalo = intervalos[intervalos.length - 1];
    const ultimaFecha = ultimoIntervalo[ultimoIntervalo.length - 1];
    if (esDiaSiguienteDT(dts[i], ultimaFecha)) {
      intervalos[intervalos.length - 1].push(dts[i]);
    } else {
      intervalos.push([dts[i]]);
    }
  }

  return intervalos.map((int) => int.map((dt) => dt.toISODate() || ""));
};

export const hoy = (): string => {
  return DateTime.now().toISODate();
};

export const obtenerNoches = (fechas: string[]): string[] => {
  const intervalos: Array<Array<string>> = obtenerIntervalos(fechas);
  return intervalos.flatMap((intervalo) =>
    intervalo.slice(0, intervalo.length - 1)
  );
};

// Chequea que dos listas de fechas sean iguales.
export const fechasSonIguales = (fechasA: Date[], fechasB: Date[]): boolean => {
  if (fechasA === fechasB) return true;
  if (fechasA.length !== fechasB.length) return false;

  fechasA.forEach((fechaA) => {
    let matcheo = false;
    fechasB.forEach((fechaB) => {
      if (fechaA.getTime() === fechaB.getTime()) {
        matcheo = true;
      }
    });
    if (!matcheo) return false;
  });

  return true;
};

export const sumarDias = (fecha: string, dias: number): string => {
  return DateTime.fromISO(fecha).plus({ days: dias }).toISODate()!;
}

export const nochesADias = (noches: string[]): string[] => {
  if(noches.length === 0){
    return [];
  }
  const intervalosNoches: Array<Array<string>> = obtenerIntervalos(noches);
  const intervalosDias = intervalosNoches.map(intervaloNoches => {
    const ultimaNoche = intervaloNoches[intervaloNoches.length - 1];
    let intervaloDias = [...intervaloNoches];
    intervaloDias.push(sumarDias(ultimaNoche, 1));
    return intervaloDias;
  });
  return intervalosDias.flatMap(intervalo => intervalo);
}

export const haceUnAno = (): string => {
  return DateTime.now().minus({ years: 1 }).toISODate();
}

export const unAnoMas = (): string => {
  return DateTime.now().plus({ years: 1 }).toISODate();
}